"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.SearchBarSkeleton = void 0;

var _react = _interopRequireDefault(require("react"));

var _Skeleton = _interopRequireDefault(require("@material-ui/lab/Skeleton"));

var _core = require("@material-ui/core");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var useStyles = (0, _core.makeStyles)({
  searchBox: {
    marginTop: 0
  }
});

var SearchBarSkeleton = function SearchBarSkeleton() {
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_Skeleton["default"], {
    width: "100%",
    height: 40,
    className: classes.searchBox
  });
};

exports.SearchBarSkeleton = SearchBarSkeleton;
var _default = SearchBarSkeleton;
exports["default"] = _default;